import {useState} from 'react';
import ImageWrapper from '../../../ImageWrapper/ImageWrapper';
import Currency from '../../../../config/Currency';
import CurrencyFormat from 'react-currency-format';
import warningIcon from './images/error.png';
import './ComparisonChangerProduct.css';

function ComparisonChangerProduct({
    index,
    product,
    selected,
    previouslySelected,
    hoverColor,
    selectionColor,
    previousSelectionColor,
    taxMultiplier,
    discountBackgroundColor,
    discountLabelColor,
    exclusivePriceLabelColor,
    exclusivePriceIcon,
    onClick
}) {
    const currencyFormat = Currency.CLP;
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseEnter = () => {
        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
    };

    const handleClick = () => {
        if (!previouslySelected && onClick) onClick(index, product);
    };

    const getPriceWithTaxes = (price) => {
        return taxMultiplier ? price * taxMultiplier : price;
    };

    const productStyle = () => {
        let color = undefined;
        if (previouslySelected) {
            color = previousSelectionColor || '#B0E0E6';
        } else {
            if (selected) {
                color = selectionColor || 'rgba(0, 0, 0, 0.3)';
            } else {
                if (isHovering) {
                    color = hoverColor || 'rgba(0, 0, 0, 0.1)';
                } else {
                    color = 'transparent';
                }
            }
        }
        return {
            backgroundColor: color
        };
    };

    const discountStyle = () => {
        return {
            background: discountBackgroundColor || '#005B80',
            color: discountLabelColor || '#FFFFFF'
        };
    };

    const exclusivePriceStyle = () => {
        return {
            color: exclusivePriceLabelColor || '#005B80'
        };
    };

    const renderAsExclusivePrice = (price, discount) => {
        return (
            <div className='comparison-changer-product-price exclusive' style={exclusivePriceStyle()}>
                <CurrencyFormat
                    prefix={currencyFormat.prefix}
                    suffix={currencyFormat.suffix}
                    thousandSeparator={currencyFormat.thousandsSeparator}
                    decimalSeparator={currencyFormat.decimalSeparator}
                    decimalScale={currencyFormat.decimalScale}
                    value={getPriceWithTaxes(price)}
                    displayType='text'
                />
                {exclusivePriceIcon && (
                    <div className='comparison-changer-product-price-info-card'>
                        <ImageWrapper image={exclusivePriceIcon} alt='Card' display='block' width={35} height='auto' loadDelay={0.2}/>
                    </div>
                )}
                {discount && discount > 0 ? <div className='comparison-changer-product-price-discount' style={discountStyle()}>{discount}%</div> : null}
            </div>
        );
    };

    const renderAsOfferPrice = (price, discount) => {
        return (
            <div className='comparison-changer-product-price offer'>
                <CurrencyFormat
                    prefix={currencyFormat.prefix}
                    suffix={currencyFormat.suffix}
                    thousandSeparator={currencyFormat.thousandsSeparator}
                    decimalSeparator={currencyFormat.decimalSeparator}
                    decimalScale={currencyFormat.decimalScale}
                    value={getPriceWithTaxes(price)}
                    displayType='text'
                />
                {discount && discount > 0 ? <div className='comparison-changer-product-price-discount' style={discountStyle()}>{discount}%</div> : null}
            </div>
        );
    };

    const renderAsNormalPrice = (price) => {
        return (
            <div className='comparison-changer-product-price normal'>
                <span>Antes: </span>
                <div className='comparison-changer-product-price-wrapper'>
                    <CurrencyFormat
                        prefix={currencyFormat.prefix}
                        suffix={currencyFormat.suffix}
                        thousandSeparator={currencyFormat.thousandsSeparator}
                        decimalSeparator={currencyFormat.decimalSeparator}
                        decimalScale={currencyFormat.decimalScale}
                        value={getPriceWithTaxes(price)}
                        displayType='text'
                    />
                </div>
            </div>
        );
    };

    return (
        <div key={`comparison-changer-product-${product.id}`} className='comparison-changer-product' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick} style={productStyle()}>
            <div className='comparison-changer-product-left-panel'>
                <div className='comparison-changer-product-image'>
                    <ImageWrapper image={product.getMainImage('m')} alt='Product' display='block' width={80} height='auto' backgroundColor='#FFFFFF' padding={10} loadDelay={0}/>
                </div>
                <div className='comparison-changer-product-info'>
                    <div className='comparison-changer-product-brand'>{product.brand || 'Sin Marca'}</div>
                    <div className='comparison-changer-product-name'>{product.name || 'Sin Nombre'}</div>
                    <div className='comparison-changer-product-sku'>{product.sku || 'Sin SKU'}</div>
                </div>
            </div>
            {product.hasAnyPrice() && (
                <div className='comparison-changer-product-right-panel'>
                    <div className='comparison-changer-product-prices'>
                        {product.exclusivePrice && renderAsExclusivePrice(product.exclusivePrice, product.getExclusiveDiscountPercentage())}
                        {product.offerPrice && renderAsOfferPrice(product.offerPrice, product.getOfferDiscountPercentage())}
                        {product.normalPrice && product.normalPrice !== product.offerPrice && (product.offerPrice ? renderAsNormalPrice(product.normalPrice) : renderAsOfferPrice(product.normalPrice, undefined))}
                    </div>
                </div>
            )}
            {previouslySelected && (
                <div className='comparison-changer-product-previously-selected'>
                    <div className='comparison-changer-product-previously-selected-icon'>
                        <ImageWrapper image={warningIcon} alt='Warning' display='block' width={15} height='auto' loadDelay={0}/>
                    </div>
                    <span className='comparison-changer-product-previously-selected-label'>En comparador</span>
                </div>
            )}
        </div>
    );
}

export default ComparisonChangerProduct;